module.exports = __webpack_public_path__ + "static/arda-51e1af7012573f88ee015913ffd33161.jpeg";